// removed by extract-text-webpack-plugin
module.exports = {"social_footer":"social_footer__Onedb","social_body":"social_body__1kBPM","social_gif":"social_gif__-O59R"};


//////////////////
// WEBPACK FOOTER
// ./components/social_footer/style.css
// module id = 7LhK
// module chunks = 0 7 8 9 10 11 12